import React from "react";
import { Button, Header, Modal, List } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { Form, TextArea } from "semantic-ui-react";

const PopDialog = ({
  modalOpen,
  closeModal,
  history,
  details,
  value,
  handleChange,
  reset,
  status,
  onSubmit,
}) => {
  const close = () => {
    if (status) {
      closeModal();
      reset();
    } else {
      closeModal();
      history.goBack();
      reset();
    }
  };
  const save = () => {
    if (status) {
      closeModal();
    } else {
      onSubmit();
      closeModal();
      history.goBack();
    }
  };

  const { title, header, content } = details;

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    handleChange(value, name);
  };

  return (
    <Modal open={modalOpen}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content image>
        <Modal.Description>
          <Header as="h4">{header}</Header>
          {content.length > 0
            ? content.map((item, idx) => (
                <List key={idx} bulleted horizontal style={{ marginLeft: "10px" }}>
                  <List.Item style={{ paddingRight: "10px" }}>
                    <List.Header>
                      {idx + 1},{item}
                    </List.Header>
                  </List.Item>
                </List>
              ))
            : null}
        </Modal.Description>
      </Modal.Content>
      <Form>
        {status ? (
          <TextArea
            placeholder="Please enter your notes at here"
            rows={10}
            name="dsmBreakDown"
            value={value}
            onChange={handleInputChange}
          />
        ) : (
          <TextArea
            placeholder="Please enter your notes at here"
            rows={10}
            value={value}
            onChange={handleInputChange}
          />
        )}
      </Form>
      <Modal.Actions>
        <Button color="black" onClick={close}>
          Cancel
        </Button>
        <Button
          content="Save"
          labelPosition="right"
          icon="checkmark"
          onClick={save}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
};

export default withRouter(PopDialog);
